import React, { Component } from "react";
import NotificationPage from "./NotificationPage";
class Notification extends Component {
  render() {
    return (
      <div>
        <NotificationPage />
      </div>
    );
  }
}

export default Notification;
